module.exports = __webpack_public_path__ + "img/michaelblank.67ca26c6.png";